<template>
  <div class="search-app__wrapper" v-click-outside="closeOptions">
    <treeselect
      :key="searchWorks"
      multiple
      flat
      :alwaysOpen="demoOpen"
      :class="{
        search_icon_hidden: !treeselectPlaceHolder,
      }"
      disableBranchNodes
      disableFuzzyMatching
      :cacheOptions="false"
      loadingText="Загрузка списка"
      noResultsText="По данному запросу ничего не найдено"
      valueFormat="object"
      openDirection="bottom"
      :options="xlsxWorks"
      :placeholder="treeselectPlaceHolder"
      v-model="selectedWorksListForBothVariants"
      @search-change="utilSearch"
      ref="xlsxPopupList"
      @select="rightCartTriggered"
    >
      <label slot="option-label" slot-scope="{ node }">
        <p>{{ node.label }}</p>
        <span>{{
          node.raw.workPrice ? node.raw.workPrice.toFixed(1) + " руб." : ""
        }}</span>
      </label>
    </treeselect>
    <button class="btn" @click="openByBtnClick">Показать</button>
    <template v-if="!hideFixedBtn">
        <FormApiCart
          @closeRightCart="closeRightCart"
          @goToStep="setAppStep"
          :assets_url="assets_url"
          :class="{active : getBothSelectedWorks.length && open}"
        ></FormApiCart>
        <div
          class="fixed_cart"
          @click="open = !open"
          :class="{ disable: !getBothSelectedWorks.length || open }"
        >
          <svg
            width="49"
            height="49"
            viewBox="0 0 49 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.3081 41.4619C11.3081 42.5027 10.939 43.3908 10.2034 44.1264C9.46778 44.8627 8.57903 45.2311 7.53773 45.2311C6.49798 45.2311 5.60923 44.8627 4.87363 44.1264C4.13732 43.3908 3.76891 42.5027 3.76891 41.4619C3.76891 40.421 4.13691 39.5329 4.87363 38.7966C5.60923 38.061 6.49798 37.6926 7.53773 37.6926C8.57903 37.6926 9.46778 38.061 10.2034 38.7966C10.939 39.5329 11.3081 40.421 11.3081 41.4619Z"
              fill="#ffffff"
            />
            <path
              d="M0.559639 8.0975C0.932796 7.72444 1.37423 7.53786 1.88477 7.53786H37.2505C37.2704 7.40058 37.3146 7.15047 37.3833 6.78732C37.452 6.42396 37.5058 6.13455 37.5451 5.91837C37.5846 5.70311 37.6578 5.44279 37.766 5.13853C37.874 4.83406 38.0016 4.59333 38.1488 4.41707C38.2958 4.23987 38.492 4.08816 38.7375 3.96016C38.9828 3.83299 39.2627 3.76904 39.5766 3.76904H47.115C47.6258 3.76904 48.0674 3.95593 48.4404 4.32847C48.8134 4.70142 49 5.14338 49 5.65371C49 6.16404 48.8134 6.60579 48.4404 6.97874C48.0671 7.3518 47.6254 7.53817 47.115 7.53817H41.1085L35.8966 31.7735C35.9356 31.8519 36.1368 32.2245 36.5002 32.8923C36.8634 33.5602 37.1529 34.1439 37.3686 34.6445C37.5845 35.1456 37.6925 35.5331 37.6925 35.8078C37.6925 36.3181 37.5059 36.7599 37.1331 37.1335C36.7596 37.5054 36.3181 37.6926 35.8076 37.6926H33.923H7.53838H5.65494C5.1446 37.6926 4.70275 37.5055 4.32991 37.1335C3.95654 36.7601 3.77017 36.3182 3.77017 35.8078C3.77017 35.2973 3.95654 34.8555 4.32991 34.4827C4.70265 34.11 5.1445 33.9229 5.65494 33.9229H32.7456C32.2743 32.9804 32.0387 32.3529 32.0387 32.0387C32.0387 31.8418 32.0632 31.6258 32.1124 31.3907C32.1616 31.1557 32.2204 30.8951 32.2891 30.6101C32.3579 30.3262 32.4018 30.1151 32.4214 29.9775L1.67788 26.385C1.18765 26.3257 0.784893 26.1154 0.470833 25.7518C0.15667 25.3889 0 24.9718 0 24.5004V9.42315C0.000205994 8.91281 0.186272 8.47107 0.559639 8.0975Z"
              fill="#ffffff"
            />
            <path
              d="M37.6924 41.4619C37.6924 42.5027 37.3245 43.3908 36.5882 44.1264C35.8517 44.8627 34.9637 45.2311 33.9229 45.2311C32.8828 45.2311 31.9943 44.8627 31.2583 44.1264C30.522 43.3908 30.1537 42.5027 30.1537 41.4619C30.1537 40.421 30.5217 39.5329 31.2583 38.7966C31.9944 38.061 32.8828 37.6926 33.9229 37.6926C34.9636 37.6926 35.8521 38.061 36.5882 38.7966C37.3241 39.5329 37.6924 40.421 37.6924 41.4619Z"
              fill="#ffffff"
            />
          </svg>
          <p v-if="getBothSelectedWorks.length">
            {{ getBothSelectedWorks.length }}
          </p>
        </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    assets_url: { type: String },
  },
  data: () => ({
    xlsxWorkList: [],
    selectedList: [],
    searchWorks: 1,
    treeselectPlaceHolder: "Выберите услугу",
    open: false,
    demoOpen: false,
    hideFixedBtn: false,
    closeOptions: {
      exclude: [],
      handler: "closeTreeselectEvent",
    },
  }),
  mounted() {
    window.addEventListener("scroll", this.hideFixedCartBtn);
  },
  methods: {
    hideFixedCartBtn() {
      let m = document.querySelector(".app");
      if (
        m.getBoundingClientRect().y < 600 &&
        m.getBoundingClientRect().y > -700
      ) {
        this.hideFixedBtn = true;
      } else {
        this.hideFixedBtn = false;
      }
    },
    openByBtnClick() {
      this.demoOpen = !this.demoOpen;
    },
    closeRightCart() {
      this.open = !this.open;
    },
    openTreeselect() {
      this.demoOpen = true;
    },
    closeTreeSelect() {
      this.demoOpen = false;
    },

    closeTreeselectEvent: function () {
      this.closeTreeSelect();
    },

    setAppStep(step) {
      this.$store.dispatch("setStep", step).then(() => {
        setTimeout(() => {
          $(".app")[0].scrollIntoView({ block: "center" });
        }, 500);
      });
    },
    utilSearch(text) {
      this.treeselectPlaceHolder = text ? "" : "Выберите услугу";
    },
    openCartPopup() {
      this.$store.dispatch("updateStateValue", {
        target: "cartPopupIsOpened",
        value: true,
      });

      document.querySelector("body").style.overflow = "hidden";
    },
    openList() {
      $(".xlsxList").trigger("click");
    },
  },
  computed: {
    xlsxWorks() {
      return this.$store.getters["getValue"]("exlsWorks");
    },
    selectedXlsxWorks() {
      return this.$store.getters["getValue"]("selectedExlsWorks");
    },
    getBothSelectedWorks() {
      return this.$store.getters.getBothSelectedWorks;
    },
    availableStep: function () {
      return this.$store.getters.getAvailableStep;
    },
    selectedWorksListForBothVariants: {
      set(value) {
        let apiWorks = [],
          xlsxWorks = [];

        value.filter((item, key) => {
          if (Number(item.id)) {
            apiWorks.push(item);
          } else {
            xlsxWorks.push(item);
          }
        });

        this.$store.dispatch("setWorks", {
          api: apiWorks,
          xlsx: xlsxWorks,
        });
      },
      get() {
        return this.$store.getters.getBothSelectedWorks;
      },
    },
    rightCartTriggered() {
      if (this.getBothSelectedWorks.length && document.documentElement.clientWidth > 768) {
        this.open = true;
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", hideFixedCartBtn);
  },
};
</script>